module.exports = __webpack_public_path__ + "static/media/emotion_detection.09e32aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/optimized/emotion_detection.png
// module id = 164
// module chunks = 0